import { useSelector } from "react-redux";

const useTier = () => {
  const tierState = useSelector((state) => state.tierState);
  const userState = useSelector((state) => state.userState);

  const currentTier = tierState.tiers.find(
    (tier) => tier.id === userState.currentPeriod.tier
  ) ?? {};

  const nextTier = tierState.tiers.find(
    (tier) => tier.id === userState.nextPeriod.tier
  ) ?? {};

  return [currentTier, nextTier] ;
};

export default useTier;
